<template>

<div  class="container" >

<div class="modal" id="staticChangePassWord" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">

      <div  class="modal-header border-primary">
        <h4 class="modal-title" id="staticBackdropLabel">
          <i  class="fas fa-user-edit mr-2" aria-hidden="true"></i>
          <strong><span style="color:#3366CC">CAMBIO PASSWORD</span></strong></h4>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>    
      <div class="modal-body">

        <changePasswordForm></changePasswordForm>
  
      </div>
      <!--
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" data-dismiss="modal">Chiudi</button>
        
      </div>
    -->
    </div>
  </div>
</div>




  
</div>

</template>
<script>


import api from '@/api'
import changePasswordForm   from '@/components/login/ChangePassWordForm.vue'
import { mapGetters }       from 'vuex';
export default {
  components: {changePasswordForm},
 data () {
    return {

    

    }
  },


}

</script>
<style scoped>
.modal-content {
  -webkit-border-radius: 0px !important;
  -moz-border-radius: 0px !important;
  border-radius: 15px !important;
  -webkit-border: 0px !important;
  -moz-border: 15px !important;
  border: 0px !important;
}
</style>